export default {
  'pages.layouts.userLayout.title': 'Ant Design 是西湖区最具影响力的 Web 设计规范',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名和密码（admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.kybInitWarning':
    'KYB 档案创建失败，部分功能可能不可用，请稍后重试或联系管理员',
  'pages.login.username.label': '用户名',
  'pages.login.username.placeholder': '请输入用户名',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '请输入密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.submitLoading': '登录中...',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.leftTitle': '为企业打造的全球支付与资金管理平台',
  'pages.login.leftSubtext': '连接银行与支付网络，实现高效、安全的资金流转',
  'pages.login.formTitle': '欢迎回来！',
  'pages.login.formSubtitle': '请登录以访问您的账户。',
  'pages.login.username.tooltip': 'admin / user',
  'pages.login.password.label': '密码',
  'pages.login.password.show': '显示密码',
  'pages.login.password.hide': '隐藏密码',
  'pages.login.signUp': '注册',
  'pages.login.footer': '没有账户？',
  'pages.login.registerAccount': '注册账户',
  'pages.login.agreement.prefix': '我已阅读并同意',
  'pages.login.agreement.serviceAgreement': '《服务协议》',
  'pages.login.agreement.and': '和',
  'pages.login.agreement.privacyPolicy': '《隐私政策》',
  'pages.login.agreement.required': '请阅读并同意《服务协议》与《隐私政策》后再登录',
  'pages.agreement.back': '返回登录',
  'pages.agreement.brand': '泛亚支付',

  'pages.register.leftTitle': '为企业打造的全球支付与资金管理平台',
  'pages.register.leftSubtext': '连接银行与支付网络，实现高效、安全的资金流转',
  'pages.register.formTitle': '创建账户',
  'pages.register.formSubtitle': '填写以下信息完成注册。',
  'pages.register.email.label': '邮箱',
  'pages.register.email.placeholder': '请输入邮箱地址',
  'pages.register.email.required': '请输入邮箱！',
  'pages.register.email.invalid': '邮箱格式不正确！',
  'pages.register.username.label': '用户名',
  'pages.register.username.placeholder': '请输入用户名',
  'pages.register.username.required': '请输入用户名！',
  'pages.register.password.label': '密码',
  'pages.register.password.placeholder': '请设置密码（至少6位）',
  'pages.register.password.required': '请输入密码！',
  'pages.register.password.minLength': '密码长度至少6位！',
  'pages.register.password.show': '显示密码',
  'pages.register.password.hide': '隐藏密码',
  'pages.register.confirmPassword.label': '确认密码',
  'pages.register.confirmPassword.placeholder': '请再次输入密码',
  'pages.register.confirmPassword.mismatch': '两次输入的密码不一致！',
  'pages.register.agreeTerms': '我已阅读并同意',
  'pages.register.agreeTerms.required': '请同意用户协议和隐私政策！',
  'pages.register.termsLink': '《用户协议》',
  'pages.register.submit': '注册',
  'pages.register.submitLoading': '注册中...',
  'pages.register.success': '注册成功！请登录。',
  'pages.register.failure': '注册失败，请重试！',
  'pages.register.footer': '已有账户？',
  'pages.register.signIn': '登录',
  'pages.welcome.advancedComponent': '高级表格',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.advancedLayout': '高级布局',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',

  'pages.global.male': '男',
  'pages.global.female': '女',
  'pages.global.requiredMessage': '此项为必填项',
  'pages.monitoring.alerts.name': '姓名',
  'pages.monitoring.alerts.primaryName': '命中名',
  'pages.monitoring.alerts.gender': '性别',
  'pages.monitoring.alerts.country': '国籍',
  'pages.monitoring.alerts.dob': '出生日期',
  'pages.monitoring.alerts.match': '分数',
  'pages.monitoring.alerts.status': '状态',
  'pages.monitoring.alerts.alertTime': '时间',
  'pages.monitoring.alerts.category': '命中类型',
  'pages.monitoring.alerts.action': '操作',
  'pages.monitoring.alerts.review': '审核',
  'pages.monitoring.alerts.review.success': '状态已更新',
  'pages.monitoring.alerts.comment': '合规备注',

  'pages.monitoring.cases.name': '档案名称',
  'pages.monitoring.cases.alerts': '警报',
  'pages.monitoring.cases.countryorterritory': '地区/国家',
  'pages.monitoring.cases.segment': '业务地区',
  'pages.monitoring.cases.status': '状态',
  'pages.monitoring.cases.action': '操作',
  'pages.monitoring.cases.download.report': '下载报告',
  'pages.monitoring.cases.addtab': '添加过滤器视图',

  'pages.monitoring.businesscases.name': '档案名称',
  'pages.monitoring.businesscases.accountName': '企业账户名称',
  'pages.monitoring.businesscases.accountNumber': '收款银行账号',
  'pages.monitoring.businesscases.socialCode': '统一社会信用代码',

  'pages.monitoring.cases.status.mitigated': '确认（审查）',
  'pages.monitoring.cases.status.processing': '打开（需要行动）',
  'pages.monitoring.cases.status.passed': '确认（低风险）',
  'pages.monitoring.cases.status.rejected': '拒绝',

  'pages.monitoring.cases.customname': '姓名',
  'pages.monitoring.cases.any': '不限',
  'pages.monitoring.cases.view.tab.name': '视图名字',
  'pages.monitoring.cases.update': '编辑过滤器视图',
  'pages.monitoring.cases.update.operate': '编辑',
  'pages.monitoring.cases.relate': '关联',

  'pages.search.advancedSearch.searchType': '搜索类型',
  'pages.search.advancedSearch.searchType.precise': '精确',
  'pages.search.advancedSearch.searchType.near': '近似',
  'pages.search.advancedSearch.searchType.broad': '模糊',

  'pages.monitoring.casesdetail.basic.info.title': '基础信息',
  'pages.monitoring.casesdetail.card.id': '档案 ID',
  'pages.monitoring.casesdetail.create.time': '创建时间',
  'pages.monitoring.casesdetail.update.time': '更新时间',
  'pages.monitoring.casesdetail.status': '状态',
  'pages.monitoring.casesdetail.segment': '业务地区',

  'pages.monitoring.casesdetail.associations': '关联人员',
  'pages.monitoring.casesdetail.match': '匹配',
  'pages.monitoring.casesdetail.alert.time': '警报时间',
  'pages.monitoring.casesdetail.category': '类别',
  'pages.monitoring.casesdetail.review': '审查',
  'pages.monitoring.casesdetail.profile': '资料',
  'pages.monitoring.casesdetail.gender': '性别',
  'pages.monitoring.casesdetail.dob': '出生日期',
  'pages.monitoring.casesdetail.relationShip': '关系',
  'pages.monitoring.casesdetail.last.screening.time': '上次筛查时间',
  'pages.monitoring.casesdetail.relateAlert': '相关警报',

  'pages.monitoring.profile': '关联信息',
  'pages.monitoring.profile.basicInfo': '基础信息',
  'pages.monitoring.profile.phase': '阶段',
  'pages.monitoring.profile.lastName': '姓氏',
  'pages.monitoring.profile.lastNameEn': '英文姓氏',
  'pages.monitoring.profile.fullName': '全名',

  'pages.monitoring.profile.firstName': '名',
  'pages.monitoring.profile.firstNameEn': '英文名',

  'pages.monitoring.profile.Gender': '性别',
  'pages.monitoring.profile.nationality': '国籍',
  'pages.monitoring.profile.dob': '出生日期',
  'pages.monitoring.profile.occupation': '职业',

  'pages.monitoring.profile.address': '地址',
  'pages.monitoring.profile.address.country': '国家',
  'pages.monitoring.profile.address.state': '州 /省',
  'pages.monitoring.profile.address.city': '城市',
  'pages.monitoring.profile.address.district': '街道',
  'pages.monitoring.profile.address.address': '详细地址',
  'pages.monitoring.profile.address.postCode': '邮政编码',

  'pages.monitoring.profile.idDetail': '证明详情',
  'pages.monitoring.profile.idType': '类型',
  'pages.monitoring.profile.idNumber': '证件号码',
  'pages.monitoring.profile.idCountry': '发行国家',
  'pages.monitoring.profile.idExpiryDate': '证件过期时间',
  'pages.monitoring.profile.idIssueDate': '签发日期',
  'pages.monitoring.profile.viewCertificate': '查看证件',

  'pages.monitoring.profile.report': '报告',
  'pages.monitoring.profile.report.upload': '上传',
  'pages.monitoring.profile.report.history': '历史',
  'pages.monitoring.profile.preview': '预览',

  'pages.monitoring.profile.report.collectedTime': '收集时间',
  'pages.monitoring.profile.report.relateFile': '相关文件',

  'pages.monitoring.profile.Image.front': '正面',
  'pages.monitoring.profile.Image.back': '背面',
  'pages.monitoring.profile.Image.side': '侧面',
  'pages.monitoring.profile.sex': '性别',
  'pages.monitoring.profile.email': '邮箱',
  'pages.monitoring.profile.country': '国家',
  'pages.monitoring.profile.state': '州 /省',
  'pages.monitoring.profile.city': '城市',
  'pages.monitoring.profile.district': '街道',
  'pages.monitoring.profile.postCode': '邮政编码',
  'pages.monitoring.profile.male': '男',
  'pages.monitoring.profile.Female': '女',
  'pages.monitoring.profile.female': '女',
  'pages.monitoring.profile.edit.custom': '编辑用户信息',
  'pages.monitoring.alerts.payer.status': '付款人状态',
  'pages.monitoring.alerts.beneficiary.status': '收款人状态',
  'pages.monitoring.alerts.idNumber': '证件号码',
  'pages.monitoring.alerts.payer': '付款人',
  'pages.monitoring.alerts.beneficiary': '收款人',
  'pages.monitoring.alerts.customerType': '客户类型',
  'pages.monitoring.alerts.check.status': '审核状态',
  'pages.monitoring.alerts.check.checked': '已审核',
  'pages.monitoring.alerts.check.needcheck': '待审核',
  'pages.monitoring.alerts.screeningId': '筛查id',

  'pages.monitoring.casesdetail.Reason': '风险原因',
  'pages.monitoring.casesdetail.relateRisk': '关联风险',
  'pages.monitoring.casesdetail.relateRiskType': '风险类型',
  'pages.monitoring.casesdetail.operate': '操作',
  'pages.monitoring.casesdetail.relateRisk.credentials': '证件风险',
  'pages.monitoring.casesdetail.downValidation': '道琼斯认证',
  'pages.monitoring.casesdetail.downValidation.passed': '通过',
  'pages.monitoring.casesdetail.downValidation.failed': '失败',
  'pages.monitoring.casesdetail.downValidation.pending': '未验证',
  'pages.monitoring.cases.step.passed': '通过',
  'pages.monitoring.cases.step.failed': '失败',
  'menu.monitoring.beneficiarycases': '收款人档案',
  'menu.monitoring.beneficiaryprofile': '收款人信息',
  'pages.monitoring.cases.beneficiary': '收款人名字',
  'pages.monitoring.cases.payer': '档案名字',
  'pages.monitoring.cases.risk.level': '风险等级',
  'pages.monitoring.profile.Male': '男',
  'pages.monitoring.cases.downValidation': '道琼斯验证',
  'pages.monitoring.cases.bankcard.id': '银行卡号',
  'pages.monitoring.cases.phone': '手机号',
  'pages.monitoring.cases.alertidandname': '警报ID / 名字',
  'pages.monitoring.cases.created.time': '创建时间',
  'pages.monitoring.cases.update.time': '评估时间',
  'pages.monitoring.cases.rejectedType': '拒绝类型',

  'pages.reports.search': '请输入订单号',
  'pages.reports.record.create': '创建',
  'pages.reports.record.update': '编辑',
  'pages.reports.record.tmp.doenload': '模版下载',
  'pages.reports.record.order.no': '订单号',
  'pages.reports.record.order.amount': '交易金额',
  'pages.reports.record.order.cur': '交易币种',
  'pages.reports.record.order.payee': '付款人',
  'pages.reports.record.order.payer': '收款人',
  'pages.reports.record.order.date': '交易日期',
  'pages.reports.record.order.status': '交易状态',
  'pages.reports.record.order.purpose': '交易目的',
  'pages.reports.record.order.step': '当前进度',
  'pages.reports.record.order.describe': '情况分析',
  'pages.reports.record.order.primaryRemark': '初审意见',
  'pages.reports.record.order.reviewRemark': '复审意见',
  'pages.reports.record.order.remark': '备注',
  'pages.reports.record.order.fileList': '附件',
  'pages.reports.record.order.operate': '操作',
  'pages.reports.record.order.review.pass': '复审通过',
  'pages.reports.record.order.review.reject': '拒绝',
  'pages.reports.record.order.delete': '删除',
  'pages.reports.record.order.upload': '上传相关文件',
  'pages.reports.record.order': '可疑记录',
  'pages.reports.record.input': '请输入',
  'pages.reports.record.select': '请选择',
  'pages.reports.record.success': '操作成功',
  'pages.reports.record.failed': '操作失败',
  'pages.monitoring.alerts.remark': '备注',
  'pages.monitoring.search.required': '请输入需要搜索的名字',
  'pages.monitoring.search.review': '当前浏览器不支持预览，已自动下载',
  'pages.monitoring.search.error': '发生错误，请稍后重试',

  xch_00723: '交易场景',
  xch_01207: '薪酬/赡家',
  xch_01208: '企业发薪',
  xch_01209: '货物贸易',
  xch_01210: '服务贸易',
  xch_01211: '学费',
};
